import "../style/ContactForm.css";

export default function ContactForm() {
  return (
    <form
      action="https://formbold.com/s/3NvEz"
      method="post"
      className="contact-form"
    >
      <label className="contact-form__field">
        <span>Name</span>
        <input type="text" name="Name" placeholder="Your name" required />
      </label>
      <label className="contact-form__field">
        <span>Email</span>
        <input type="email" name="Email" placeholder="you@example.com" required />
      </label>
      <label className="contact-form__field">
        <span>Phone Number</span>
        <input type="tel" name="Phone Number" placeholder="+91 00000 00000" />
      </label>
      <label className="contact-form__field">
        <span>Message</span>
        <textarea
          name="Message"
          placeholder="Type your message"
          rows={4}
          required
        />
      </label>
      <button type="submit" className="btn-turmeric">
        Submit
      </button>
    </form>
  );
}
